import { render } from "./sidebar1.vue?vue&type=template&id=d2c57b68"
import script from "./sidebar1.vue?vue&type=script&lang=js"
export * from "./sidebar1.vue?vue&type=script&lang=js"

import "./sidebar1.vue?vue&type=style&index=0&id=d2c57b68&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__